__webpack_require__.p = "https://paddlepaddle-org-cn.cdn.bcebos.com/paddle-unique-front/";